import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import WhatsAppBooking from '../components/WhatsAppBooking';
import SEOJsonLd from '../../../components/base/SEOJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://thesunshinehealing.com';

const studioImage = 'https://public.readdy.ai/ai/img_res/561a5639c2d8c3dc8e54df329358952e.jpg spiritual healing studio banner design with glowing lotus flowers chakra rainbow energy light sacred geometry golden patterns serene meditation space white and gold cream color palette peaceful divine atmosphere ethereal glow natural elements Singapore wellness brand beautiful harmonious spiritual landscape with soft light rays and healing crystals&width=1200&height=630&seq=studio-og-preview-001&orientation=landscape';

const quantumJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Quantum Hypnosis QHHT — Quantum Healing Hypnosis Technique Singapore',
    description:
      'Experience Quantum Healing Hypnosis Technique (QHHT) by Dolores Cannon in Singapore. 3–4 hour deep theta hypnosis session to explore past lives, soul mission and life purpose. In-person Mandarin sessions. SGD $450.',
    url: `${siteUrl}/services/quantum`,
    image: studioImage,
    areaServed: 'Singapore',
    provider: {
      '@type': 'LocalBusiness',
      name: 'Sunshine Healing Studio',
      url: siteUrl,
      telephone: '+6593651286',
      address: { '@type': 'PostalAddress', addressLocality: 'Singapore', addressCountry: 'SG' },
    },
    offers: {
      '@type': 'Offer',
      price: '450',
      priceCurrency: 'SGD',
      description: 'Full QHHT Hypnosis Session (3–4 hours)',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页 Home', item: `${siteUrl}/` },
      { '@type': 'ListItem', position: 2, name: '量子催眠 QHHT', item: `${siteUrl}/services/quantum` },
    ],
  },
];

export default function QuantumPage() {
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen bg-white">
      <title>量子催眠 QHHT 新加坡 | Quantum Hypnosis Past Life Regression Singapore — Sunshine Healing</title>
      <meta name="description" content="新加坡量子催眠QHHT疗愈，由多洛雷斯·坎农创立，引导进入θ脑波状态探索前世今生与灵魂使命。3-4小时深度疗愈，仅限中文面对面。SGD $450. Singapore QHHT Quantum Healing Hypnosis Technique by Dolores Cannon — past life regression, soul mission, Higher Self." />
      <meta name="keywords" content="QHHT Singapore, quantum hypnosis, past life regression Singapore, Dolores Cannon, quantum healing hypnosis technique" />
      <link rel="canonical" href={`${siteUrl}/services/quantum`} />
      <meta property="og:title" content="量子催眠 QHHT 新加坡 | Quantum Hypnosis Singapore" />
      <meta property="og:description" content="深度量子催眠QHHT，探索前世今生、灵魂使命，连接高我智慧。新加坡专业QHHT疗愈师，中文面对面疗程。" />
      <meta property="og:url" content={`${siteUrl}/services/quantum`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={studioImage} />
      <SEOJsonLd id="quantum-jsonld" data={quantumJsonLd} />

      <Navbar />

      {/* Hero Banner */}
      <section className="relative min-h-[50vh] md:min-h-[60vh] flex items-center justify-center overflow-hidden pt-16 md:pt-0">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=deep%20cosmic%20consciousness%20journey%20through%20quantum%20realm%20with%20purple%20and%20indigo%20energy%20waves%2C%20subconscious%20mind%20exploration%20visualization%2C%20mystical%20hypnosis%20atmosphere%2C%20ethereal%20dreamlike%20space%2C%20spiritual%20awakening%20scene%2C%20infinite%20consciousness%20field%2C%20serene%20and%20profound%20ambiance&width=1920&height=1080&seq=quantum-hero-bg&orientation=landscape"
            alt="Quantum Hypnosis"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-stone-900/65 via-stone-900/45 to-stone-900/65"></div>
        </div>
        <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-6 text-center">
          <div className="inline-block px-4 py-1.5 bg-teal-500/20 backdrop-blur-sm rounded-full border border-teal-400/30 mb-4 md:mb-5">
            <span className="text-teal-300 text-xs md:text-sm font-medium tracking-widest">SPIRITUAL HEALING</span>
          </div>
          <h1 className="text-3xl md:text-6xl font-bold text-white mb-4 md:mb-5 tracking-tight">
            {t('quantumDetail.hero.title')}
          </h1>
          <p className="text-base md:text-xl text-stone-200 leading-relaxed">
            {t('quantumDetail.hero.description')}
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-12 md:py-24 px-4 md:px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col-reverse md:grid md:grid-cols-2 md:gap-16 md:items-center gap-8">
            <div className="relative w-full h-64 md:h-[520px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=person%20in%20deep%20meditative%20trance%20state%20with%20teal%20and%20dark%20energy%20surrounding%20consciousness%2C%20quantum%20healing%20hypnosis%20scene%2C%20subconscious%20exploration%20visualization%2C%20peaceful%20and%20profound%20atmosphere%2C%20spiritual%20journey%20through%20inner%20realms%2C%20serene%20mystical%20environment&width=800&height=1000&seq=quantum-intro-img&orientation=portrait"
                alt="Quantum Hypnosis Journey"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <p className="text-teal-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2 md:mb-3">Introduction</p>
              <h2 className="text-2xl md:text-4xl font-bold text-stone-800 mb-4 md:mb-6 leading-snug">
                {t('quantumDetail.intro.title')}
              </h2>
              <p className="text-stone-600 leading-relaxed text-sm md:text-base">
                {t('quantumDetail.intro.content')}
              </p>
              <div className="mt-6 md:mt-10 grid grid-cols-2 gap-3 md:gap-4">
                {[
                  { icon: 'ri-time-line', label: t('quantumDetail.benefits.benefit1.title') },
                  { icon: 'ri-star-line', label: t('quantumDetail.benefits.benefit2.title') },
                  { icon: 'ri-mental-health-line', label: t('quantumDetail.benefits.benefit3.title') },
                  { icon: 'ri-lightbulb-line', label: t('quantumDetail.benefits.benefit4.title') },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-2 md:gap-3 bg-teal-50 rounded-xl px-3 md:px-4 py-2.5 md:py-3">
                    <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center text-teal-600 flex-shrink-0">
                      <i className={`${item.icon} text-base md:text-lg`}></i>
                    </div>
                    <span className="text-stone-700 text-xs md:text-sm font-medium">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* QHHT Overview + Elements + Benefits */}
      <section className="py-12 md:py-20 px-4 md:px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          {/* Overview */}
          <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
            <div className="inline-block px-4 py-1.5 bg-teal-50 rounded-full border border-teal-200 mb-4">
              <span className="text-teal-600 text-xs font-semibold tracking-widest uppercase">
                {t('quantumDetail.qhhtSection.overview.tag')}
              </span>
            </div>
            <p className="text-stone-600 leading-relaxed text-sm md:text-base">
              {t('quantumDetail.qhhtSection.overview.content')}
            </p>
          </div>

          {/* Key Elements */}
          <div className="mb-12 md:mb-16">
            <h3 className="text-xl md:text-2xl font-bold text-stone-800 mb-6 md:mb-8 text-center">
              {t('quantumDetail.qhhtSection.elements.title')}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {(t('quantumDetail.qhhtSection.elements.items', { returnObjects: true }) as { icon: string; title: string; desc: string }[]).map((item, i) => (
                <div key={i} className="bg-teal-50/70 border border-teal-100 rounded-2xl p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-teal-100 text-teal-600 flex-shrink-0">
                      <i className={`${item.icon} text-base`}></i>
                    </div>
                    <span className="font-semibold text-stone-800 text-sm md:text-base">{item.title}</span>
                  </div>
                  <p className="text-stone-500 text-xs md:text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Potential Benefits */}
          <div className="mb-8">
            <h3 className="text-xl md:text-2xl font-bold text-stone-800 mb-6 md:mb-8 text-center">
              {t('quantumDetail.qhhtSection.benefits.title')}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
              {(t('quantumDetail.qhhtSection.benefits.items', { returnObjects: true }) as { icon: string; title: string; desc: string }[]).map((item, i) => (
                <div key={i} className="flex gap-4 bg-white border border-stone-100 rounded-2xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-teal-100 text-teal-600 flex-shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div>
                    <p className="font-semibold text-stone-800 text-sm md:text-base mb-1">{item.title}</p>
                    <p className="text-stone-500 text-xs md:text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Preparation Tip */}
          <div className="max-w-2xl mx-auto">
            <div className="flex items-start gap-4 bg-teal-600 rounded-2xl px-6 py-5">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-xl text-teal-100"></i>
              </div>
              <div>
                <p className="font-semibold text-white text-sm md:text-base mb-1">
                  {t('quantumDetail.qhhtSection.preparation.title')}
                </p>
                <p className="text-teal-100 text-xs md:text-sm leading-relaxed">
                  {t('quantumDetail.qhhtSection.preparation.content')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Suitable For & Method */}
      <section className="py-12 md:py-20 px-4 md:px-6 bg-teal-50/60">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:grid md:grid-cols-2 md:gap-16 gap-10">
            {/* 适合人群 */}
            <div>
              <div className="flex items-center gap-3 mb-5 md:mb-7">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-teal-100 text-teal-600">
                  <i className="ri-user-heart-line text-lg"></i>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-stone-800">{t('quantumDetail.suitable.title')}</h3>
              </div>
              <ul className="space-y-3">
                {[
                  t('quantumDetail.suitable.item1'),
                  t('quantumDetail.suitable.item2'),
                  t('quantumDetail.suitable.item3'),
                  t('quantumDetail.suitable.item4'),
                  t('quantumDetail.suitable.item5'),
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-stone-600 text-sm md:text-base">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-base"></i>
                    </div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            {/* 疗愈方式 */}
            <div>
              <div className="flex items-center gap-3 mb-5 md:mb-7">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-teal-100 text-teal-600">
                  <i className="ri-magic-line text-lg"></i>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-stone-800">{t('quantumDetail.method.title')}</h3>
              </div>
              <div className="space-y-4">
                {[
                  { icon: 'ri-moon-foggy-line', title: t('quantumDetail.method.step1.title'), desc: t('quantumDetail.method.step1.desc') },
                  { icon: 'ri-brain-line', title: t('quantumDetail.method.step2.title'), desc: t('quantumDetail.method.step2.desc') },
                  { icon: 'ri-heart-add-line', title: t('quantumDetail.method.step3.title'), desc: t('quantumDetail.method.step3.desc') },
                ].map((item, i) => (
                  <div key={i} className="flex gap-4 p-4 bg-white rounded-xl shadow-sm border border-teal-100">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-teal-100 text-teal-600 flex-shrink-0">
                      <i className={`${item.icon} text-base`}></i>
                    </div>
                    <div>
                      <p className="font-semibold text-stone-800 text-sm md:text-base mb-1">{item.title}</p>
                      <p className="text-stone-500 text-xs md:text-sm leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-12 md:py-20 px-4 md:px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-teal-100 text-teal-600">
              <i className="ri-price-tag-3-line text-lg"></i>
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-stone-800">{t('quantumDetail.pricing.title')}</h3>
          </div>
          <p className="text-stone-400 text-sm mb-8">{t('quantumDetail.pricing.note')}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {(t('quantumDetail.pricing.items', { returnObjects: true }) as { duration: string; price: string; label: string }[]).map((item, i) => (
              <div key={i} className="flex-1 max-w-xs mx-auto sm:mx-0 bg-teal-50 border border-teal-100 rounded-2xl px-8 py-7 flex flex-col items-center gap-2 shadow-sm">
                <span className="text-xs font-semibold tracking-widest text-teal-500 uppercase mb-1">{item.label}</span>
                <div className="flex items-center gap-2 text-stone-700">
                  <div className="w-5 h-5 flex items-center justify-center text-teal-400">
                    <i className="ri-time-line text-base"></i>
                  </div>
                  <span className="text-base font-medium">{item.duration}</span>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-teal-600 mt-1">{item.price}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booking */}
      <WhatsAppBooking accentColor="teal" serviceName="量子催眠" />

      {/* Back */}
      <section className="py-8 md:py-10 px-4 md:px-6 text-center bg-white">
        <Link
          to="/#services"
          className="inline-flex items-center gap-2 px-6 md:px-7 py-3 border border-stone-300 text-stone-700 rounded-full hover:bg-stone-100 transition-colors duration-300 text-sm whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          <span>{t('quantumDetail.cta.back')}</span>
        </Link>
      </section>

      <Footer />
    </div>
  );
}
